import script from "./BroadcastItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastItem.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastItem.vue?vue&type=style&index=0&id=5cbcc634&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbcc634"]])

export default __exports__